module.exports = __webpack_public_path__ + "media/Experience-2.27c7bc70.mp4";